import Vue from 'vue'
import { Datetime } from 'vue-datetime'

Vue.component('datetime', Datetime)
